import React, {useState, useEffect} from 'react'
import {useNavigate} from 'react-router-dom'
import axios from 'axios';
import conf from '../../conf'
import {Switch} from '@mui/material'
import {ArrowRightRounded} from '@material-ui/icons'
import {useToasts} from 'react-toast-notifications'

const EventPopup = ()=>{

     const {addToast} = useToasts();
     const go = useNavigate();

     const defultValue = {
        enabled: false,
        heading: '',
        description: '',
     };

     const [file, setfile] = useState(null);
     const [video, setvideo] = useState(null);
     const [isSending, setIsSending] = useState(false);
     const [formData, setFormData] = useState(null);

     const getSetting = async ()=>{
          try {
               const res = await axios.get(conf.serverAddress + "admin/popup-event", {
                    headers: {"Authorization" : `Bearer ${document.cookie.split("=")[1]}`}
               });
               setFormData(res.data)
          } catch (err) {
               console.log(err);
          }
     }

     useEffect(()=>{ getSetting(); }, [])

     const onSubmit = async ()=>{

          setIsSending(true)
          try {
               const rBody = new FormData();
               rBody.append('enabled', formData.enabled);
               rBody.append('heading', formData.heading);
               rBody.append('description', formData.description);
               
               const res = await axios({
                    method: "PATCH", 
                    data: rBody,
                    url: conf.serverAddress + "admin/popup-event",
                    headers: { 
                         "Content-Type": "multipart/form-data",
                         "Authorization" : `Bearer ${document.cookie.split("=")[1]}`
                    }
               });
               setIsSending(false)
               addToast("Changes saved successfully", {
                    appearance: 'success',
                    autoDismiss: true,
               })
          } catch (error) {
               console.log(error);
               setIsSending(false)
               setFormData(defultValue)
               addToast("Failed", {
                    appearance: 'error',
                    autoDismiss: true,
               })
          }
     }

     const vBox = {
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
     };

     const sInput = {width: "440px", marginTop: "10px", border: '1px solid #8a8a8a', borderRadius: "5px", padding: '10px 15px'};

     if(!formData) return null;


     return(
          <div style={{display: 'flex', justifyContent: "center"}}>
               <div className="card" style={{width: '500px', padding: "20px 25px"}}>
                    <h3>Event Popup</h3>
                    <div style={vBox}>
                         Enabled <Switch checked={formData.enabled} onChange={(e, is)=>setFormData({
                                   ...formData,
                                   enabled: is
                              })} />
                    </div>
                    <div style={{marginTop: '15px'}}>
                         Headline <br />
                         <input value={formData.heading} type="text" style={sInput} onChange={e=> setFormData({
                              ...formData,
                              heading: e.target.value
                         })} placeholder="text..." />
                    </div>
                    <div style={{marginTop: '15px'}}>
                         Description <br />
                         <textarea style={{...sInput, height: '100px'}}  onChange={e=> setFormData({
                                    ...formData,
                                    description: e.target.value
                                })}
                            placeholder="text..." 
                            maxLength={500}
                            value={formData.description}/>
                    </div>
                    
                    <button onClick={onSubmit} className="badge badge-gradient-success"  style={{
                         width: '440px', display: 'flex', justifyContent: 'center',
                         border: 'none', borderRadius: '5px', fontSize: '16px',
                         padding: '10px 0', cursor: isSending ? 'wait' : 'pointer' ,
                         marginTop: '20px'
                    }}>Save</button>
               </div>
          </div>
     );
}
export default EventPopup;